import React, { useEffect, useState } from 'react'
import {
  View,
  Text,
  ScrollView,
  Touchable,
  TouchableOpacity,
  StyleSheet,
  Dimensions,
  Platform,
  ActivityIndicator,
  Linking
} from 'react-native'
import { Buffer } from 'buffer'
import { colorPalette, globalStyles } from '../../../static/styles/global'
import { Ionicons, AntDesign, FontAwesome } from '@expo/vector-icons'
import Card from '../../../components/shared/card/Card'
import { usepaycheckStore } from '../../../stores/paycheck'
import { paycheckbody } from '../../../types/paycheckTypes'
import { useLabourStore } from '../../../stores/labour'
import { usePersonalStore } from '../../../stores/personalInfo'
import ModalPopup from '../../../components/shared/modal/ModalPopup'
import CardSeparator from '../../../components/shared/card/CardSeparator'
import { useInitializeStore } from '../../../stores/initialize'
import moment from 'moment'
import { Float } from 'react-native/Libraries/Types/CodegenTypes'
import * as Sharing from 'expo-sharing'
import * as FileSystem from 'expo-file-system'
import { startActivityAsync } from 'expo-intent-launcher'
import { useTranslation } from 'react-i18next'
import Toast from 'react-native-toast-message'
import PaystubPdfViewer from '../../../components/pdf/PaystubPdfViewer'



type reuseparams = {
  CheckDate: string
  CheckNumber: number
  CheckAmount: Float
  action?: any
  uri: string
  payid: number
  employeenumber: number
  storeName: string
}

const PayCheckDetails = ({ navigation, route }: any) => {
  const [activeTab, setActiveTab] = useState<'current' | 'history'>('current')
  const store = usepaycheckStore()
  const intializestore = useInitializeStore()
  const labourstore = useLabourStore()
  const personalstore = usePersonalStore()

  var specifiedDate = new Date()
  specifiedDate.setMonth(specifiedDate.getMonth() - 24)
  var formattedDate = specifiedDate.toISOString()

  const data: any = {
    count: 10,
    essUserKey: intializestore?.initializeData?.userkey,
    entityId: personalstore?.personalData?.entityId,
    beginDate: new Date(),
    endDate: formattedDate
  }

  const [isModalVisible, setModalVisible] = useState(false)

  // const handleView = async (uri, payid, employeenumber) => {
  //   if (uri != null) {
  //     store.downloadFile(uri)
  //   } else {
  //     const pdfdata: any = await store.getpdfuri(payid, employeenumber)
  //     store.downloadFile(pdfdata.data?.pdfUrl)
  //   }
  // }

  const [viewingPdf, setViewingPdf] = useState<{
    base64: string | null
    title: string
    loading: boolean
  } | null>(null)

  const handleView = async (payid: Number, employeenumber: Number, checkDate?: string) => {
    try {
      const title = checkDate
        ? `Paystub - ${moment(checkDate).format('MM/DD/YYYY')}`
        : 'Paystub'

      setViewingPdf({
        base64: null,
        title,
        loading: true
      })

      const response = await store.getpdfblob(payid, employeenumber)
      const base64 = Buffer.from(response).toString('base64')

      setViewingPdf({
        base64,
        title,
        loading: false
      })
    } catch (error) {
      console.error('Error fetching paystub:', error)
      setViewingPdf(null)
      Toast.show({
        type: 'error',
        text1: 'Error',
        text2: 'Could not load paystub'
      })
    }
  }

  const formatCurrency = (amount: any) => {
    if (amount === undefined || amount === null || isNaN(Number(amount))) {
      return '$0.00'
    }
    return (
      '$' +
      new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(amount))
    )
  }

  const PaystubCard = ({
    item,
    isFirstCard = false
  }: {
    item: any
    isFirstCard?: boolean
  }) => {
    const checkDateFormatted = item?.depositDate
      ? moment(item.depositDate).format('MM/DD/YYYY')
      : '-'
    const checkNumber = item?.depositNumber ?? '-'
    const storeName = item?.storeName ?? '-'
    const netAmount = formatCurrency(
      item?.netPayCurrent ?? item?.netAmount ?? item?.netPay
    )
    const grossAmount = formatCurrency(
      item?.grossCurrent ?? item?.grossAmount ?? item?.grossPay
    )

    const isCurrentConnected = activeTab === 'current' && isFirstCard

    return (
      <View
        style={[
          styles.cardContainer,
          isCurrentConnected && styles.cardConnectedCurrent
        ]}
      >
        {/* Card Header Title */}
        <Text style={styles.cardHeaderTitle}>{t('Paystub Details')}</Text>

        {/* Cyan Underline */}
        <View style={styles.cyanLine} />

        {/* Store Name */}
        <View style={styles.fieldSection}>
          <Text style={styles.fieldLabel}>{t('Store Name')}</Text>
          <Text style={styles.fieldValue}>{storeName}</Text>
        </View>

        <View style={styles.fieldDivider} />

        {/* Check Date */}
        <View style={styles.fieldSection}>
          <Text style={styles.fieldLabel}>{t('Check Date')}</Text>
          <Text style={styles.fieldValue}>{checkDateFormatted}</Text>
        </View>

        <View style={styles.fieldDivider} />

        {/* Check Number */}
        <View style={styles.fieldSection}>
          <Text style={styles.fieldLabel}>{t('Check Number')}</Text>
          <Text style={styles.fieldValue}>{checkNumber}</Text>
        </View>

        <View style={styles.fieldDivider} />

        {/* Bottom Amounts and PDF Download Row */}
        <View style={styles.amountsRow}>
          {/* Net Amount Column */}
          <View style={styles.amountCol}>
            <Text style={styles.amountLabel}>{t('Net Amount')}</Text>
            <Text style={styles.amountValue}>{netAmount}</Text>
          </View>

          {/* Vertical Divider */}
          <View style={styles.verticalDivider} />

          {/* Gross Amount Column */}
          <View style={styles.amountCol}>
            <Text style={styles.amountLabel}>{t('Gross Amount')}</Text>
            <Text style={styles.amountValue}>{grossAmount}</Text>
          </View>

          {/* PDF Button */}
          <TouchableOpacity
            style={styles.pdfButton}
            onPress={() =>
              handleView(item?.payId, item?.employeeNumber, item?.depositDate)
            }
          >
            <FontAwesome name="file-pdf-o" size={24} color="#E53E3E" />
          </TouchableOpacity>
        </View>
      </View>
    )
  }

  useEffect(() => {
    store.paycheck(data)
  }, [])

  const { t } = useTranslation()

  const handleDownload = async (base64Data?: string | null) => {
    if (!base64Data) return
    try {
      if (Platform.OS === 'web') {
        const blob = new Blob([Buffer.from(base64Data, 'base64')], {
          type: 'application/pdf'
        })
        const url = URL.createObjectURL(blob)
        Linking.openURL(url)
      } else if (Platform.OS === 'ios') {
        let dataUri = `${FileSystem.documentDirectory}fms_downloaded_file.pdf`
        await FileSystem.writeAsStringAsync(dataUri, base64Data, {
          encoding: FileSystem.EncodingType.Base64
        })
        await Sharing.shareAsync(dataUri, {
          mimeType: 'application/pdf',
          dialogTitle: 'Share PDF'
        })
      } else if (Platform.OS === 'android') {
        let dataUri = `${FileSystem.documentDirectory}paystub_file.pdf`
        await FileSystem.writeAsStringAsync(dataUri, base64Data, {
          encoding: FileSystem.EncodingType.Base64
        })
        const cUri = await FileSystem.getContentUriAsync(dataUri)
        try {
          await startActivityAsync('android.intent.action.VIEW', {
            data: cUri,
            flags: 1,
            type: 'application/pdf'
          })
        } catch (intentErr) {
          await Sharing.shareAsync(dataUri, {
            mimeType: 'application/pdf',
            dialogTitle: 'Share PDF'
          })
        }
      }
    } catch (error) {
      console.error('Error downloading paystub:', error)
      Toast.show({
        type: 'error',
        text1: 'Error',
        text2: 'Could not download paystub'
      })
    }
  }

  if (viewingPdf) {
    return (
      <PaystubPdfViewer
        base64Data={viewingPdf.base64}
        title={viewingPdf.title}
        isLoading={viewingPdf.loading}
        onBack={() => setViewingPdf(null)}
        onDownload={() => handleDownload(viewingPdf.base64)}
      />
    )
  }

  const paystubs =
    store && store.paycheckData && Array.isArray(store.paycheckData)
      ? store.paycheckData
      : []

  const currentPaystub = paystubs.length > 0 ? paystubs[0] : null
  const historyPaystubs = paystubs.length > 1 ? paystubs.slice(1) : []

  return (
    <ScrollView
      style={styles.screenContainer}
      contentContainerStyle={styles.scrollContent}
      showsVerticalScrollIndicator={false}
    >
      {/* Top Header */}
      <View style={styles.headerBand}>
        <View style={styles.backButtonContainer}>
          <TouchableOpacity
            onPress={() => navigation.navigate('PayrollDocuments')}
            style={styles.backButton}
          >
            <Ionicons
              name="chevron-back"
              size={24}
              color={colorPalette.white}
            />
            <Text style={styles.backButtonText}>
              {t('Payroll Documents')}
            </Text>
          </TouchableOpacity>
        </View>

        <Text style={styles.headerTitle}>
          {t('Paystub Details')}
        </Text>
      </View>

      {/* Tab Switcher: Current and History */}
      <View style={styles.tabContainer}>
        <TouchableOpacity
          style={[
            styles.tabButton,
            activeTab === 'current' && styles.activeTabButton
          ]}
          onPress={() => setActiveTab('current')}
        >
          <Text
            style={[
              styles.tabText,
              activeTab === 'current' && styles.activeTabText
            ]}
          >
            {t('Current')}
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={[
            styles.tabButton,
            activeTab === 'history' && styles.activeTabButton
          ]}
          onPress={() => setActiveTab('history')}
        >
          <Text
            style={[
              styles.tabText,
              activeTab === 'history' && styles.activeTabText
            ]}
          >
            {t('History')}
          </Text>
        </TouchableOpacity>
      </View>

      {/* Tab Content */}
      {store.loading ? (
        <View style={styles.loadingContainer}>
          <ActivityIndicator size="large" color="#FFFFFF" />
        </View>
      ) : activeTab === 'current' ? (
        currentPaystub ? (
          <PaystubCard item={currentPaystub} isFirstCard={true} />
        ) : (
          <View style={[styles.emptyContainer, styles.cardConnectedCurrent]}>
            <Text style={styles.emptyText}>{t('No Paystubs are available')}</Text>
          </View>
        )
      ) : historyPaystubs.length > 0 ? (
        historyPaystubs.map((item, index) => (
          <View key={item?.depositNumber || index} style={{ marginBottom: 14 }}>
            <PaystubCard item={item} isFirstCard={index === 0} />
          </View>
        ))
      ) : (
        <View style={styles.emptyContainer}>
          <Text style={styles.emptyText}>
            {paystubs.length === 0
              ? t('No Paystubs are available')
              : t('No paystub history available')}
          </Text>
        </View>
      )}
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  screenContainer: {
    flex: 1,
    backgroundColor: '#0B495C'
  },
  scrollContent: {
    paddingBottom: 40
  },
  headerBand: {
    paddingHorizontal: 20,
    paddingTop: 16,
    paddingBottom: 8
  },
  backButtonContainer: {
    marginBottom: 14
  },
  backButton: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  backButtonText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '500',
    marginLeft: 4
  },
  headerTitle: {
    color: '#FFFFFF',
    fontSize: 28,
    fontWeight: '700',
    textAlign: 'center'
  },
  tabContainer: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginHorizontal: 18,
    marginTop: 18,
    marginBottom: 0
  },
  tabButton: {
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderTopWidth: 2,
    borderLeftWidth: 2,
    borderRightWidth: 2,
    borderBottomWidth: 0,
    borderColor: 'transparent',
    paddingHorizontal: 22,
    paddingTop: 8,
    paddingBottom: 9,
    marginRight: 6,
    backgroundColor: 'transparent'
  },
  activeTabButton: {
    borderColor: '#FFFFFF',
    backgroundColor: '#0B495C'
  },
  tabText: {
    color: '#FFFFFF',
    fontSize: 15,
    fontWeight: '600',
    opacity: 0.85
  },
  activeTabText: {
    fontWeight: '700',
    opacity: 1
  },
  cardContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    paddingHorizontal: 20,
    paddingTop: 18,
    paddingBottom: 22,
    marginHorizontal: 18,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.12,
    shadowRadius: 10,
    elevation: 4
  },
  cardConnectedCurrent: {
    borderTopLeftRadius: 0
  },
  cardHeaderTitle: {
    fontSize: 22,
    fontWeight: '800',
    color: '#0B495C',
    letterSpacing: -0.2
  },
  cyanLine: {
    height: 2,
    backgroundColor: '#4FC7E8',
    marginTop: 8,
    marginBottom: 16
  },
  fieldSection: {
    paddingVertical: 2
  },
  fieldLabel: {
    fontSize: 14,
    color: '#718096',
    fontWeight: '500',
    marginBottom: 4
  },
  fieldValue: {
    fontSize: 17,
    color: '#1A202C',
    fontWeight: '600'
  },
  fieldDivider: {
    height: 1,
    backgroundColor: '#EDF2F7',
    marginVertical: 12
  },
  amountsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 4
  },
  amountCol: {
    flex: 1
  },
  amountLabel: {
    fontSize: 13,
    color: '#718096',
    fontWeight: '500',
    marginBottom: 4
  },
  amountValue: {
    fontSize: 20,
    color: '#0B495C',
    fontWeight: '700'
  },
  verticalDivider: {
    width: 1,
    height: 38,
    backgroundColor: '#EDF2F7',
    marginHorizontal: 12
  },
  pdfButton: {
    paddingHorizontal: 8,
    paddingVertical: 6,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    marginLeft: 10
  },
  emptyContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 30,
    marginHorizontal: 18,
    alignItems: 'center',
    justifyContent: 'center'
  },
  emptyText: {
    color: '#718096',
    fontSize: 16,
    fontWeight: '500'
  },
  loadingContainer: {
    marginTop: 40,
    alignItems: 'center',
    justifyContent: 'center'
  }
})
export default PayCheckDetails
